import React from 'react';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { Product } from '../../services/inventory.service';
import { formatNumber } from '../ui/FormControls';

interface ProductStockSummaryProps {
  product: Product;
  // When set, shows the stock level the pending change would produce
  newStock?: number;
}

// Header strip shared by the stock dialogs: which product, and its stock level
const ProductStockSummary: React.FC<ProductStockSummaryProps> = ({ product, newStock }) => {
  const hasChange = newStock !== undefined && newStock !== Number(product.currentStock);

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold text-gray-900">{product.name}</p>
        <p className="mt-0.5 text-xs text-gray-500">
          <span className="font-mono">{product.sku}</span>
          {product.category ? ` · ${product.category}` : ''}
        </p>
      </div>
      <div className="flex items-center gap-3 text-right">
        <div>
          <p className="text-xs text-gray-500">Current stock</p>
          <p className="text-base font-semibold text-gray-900 tabular-nums">
            {formatNumber(product.currentStock)}{' '}
            <span className="text-xs font-normal text-gray-500">{product.unit}</span>
          </p>
        </div>
        {hasChange && (
          <>
            <ArrowRightIcon className="h-4 w-4 text-gray-400" aria-hidden="true" />
            <div>
              <p className="text-xs text-gray-500">After change</p>
              <p
                className={`text-base font-semibold tabular-nums ${
                  (newStock as number) < 0 ? 'text-red-600' : 'text-gray-900'
                }`}
              >
                {formatNumber(newStock as number)}{' '}
                <span className="text-xs font-normal text-gray-500">{product.unit}</span>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ProductStockSummary;
